import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { ViolationType } from './types';

export const violationTypesApi = createApi({
  reducerPath: 'violationTypes',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/violation-types',
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getViolationTypes: builder.query<ViolationType[], void>({
      query: () => ({
        url: '/',
      }),
    }),
  }),
});

export const { useGetViolationTypesQuery } = violationTypesApi;
